'use client';

import styles from './styles/modals.module.css';
import { COURSE_FIELD_RULES } from '@/config/courseFieldRules';

const { learningGoals: LEARNING_GOALS_RULES } = COURSE_FIELD_RULES;

function LearningGoalsCharHint({ value }) {
  const length = (value || '').length;
  const min = LEARNING_GOALS_RULES.minLength;
  const max = LEARNING_GOALS_RULES.maxLength;

  if (length < min) {
    const needed = min - length;
    return (
      <div className={styles.charCounter}>
        {needed} more characters needed
      </div>
    );
  }

  if (length > max) {
    return (
      <div className={styles.charCounter}>
        Too many text — please shorten your learning goals.
      </div>
    );
  }

  const left = Math.max(0, max - length);

  return (
    <div className={styles.charCounter}>
      {left} characters left (Optional)
    </div>
  );
}

export default function LearningGoalsModal({
  isOpen,
  onClose,
  learningGoalsContent,
  setLearningGoalsContent,
  onSave
}) {
  if (!isOpen) return null;

  const contentLength = (learningGoalsContent || '').length;
  const min = LEARNING_GOALS_RULES.minLength;
  const max = LEARNING_GOALS_RULES.maxLength;

  const isTooShort = contentLength < min;
  const isTooLong = contentLength > max;
  const isInvalid = isTooShort || isTooLong;

  return (
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <span className={styles.close} onClick={onClose}>&times;</span>
        <h2>Edit Learning Goals:</h2>

        <label className={styles.formLabel} htmlFor="learningGoalsContent">
          Learning Goals
        </label>

        <textarea
          id="learningGoalsContent"
          className={styles.courseLearningInput}
          value={learningGoalsContent}
          onChange={(e) => setLearningGoalsContent(e.target.value)}
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}
          required={LEARNING_GOALS_RULES.required}
          minLength={LEARNING_GOALS_RULES.minLength}
          maxLength={LEARNING_GOALS_RULES.maxLength}
        />

        <LearningGoalsCharHint value={learningGoalsContent} />

        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          onClick={onSave}
          style={{
            marginTop: '1rem',
            opacity: isInvalid ? 0.6 : 1,
            cursor: isInvalid ? 'not-allowed' : 'pointer',
          }}
          disabled={isInvalid}
        >
          {isTooLong
            ? 'Too many lines of details'
            : isTooShort
            ? 'Need more details'
            : 'Save'}
        </button>
      </div>
    </div>
  );
}